import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useStaticQuery, graphql } from "gatsby";
import { Link, PREVIEW } from "gatsby";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import { I18nContext } from "@/i18n/index";
// import sdfsdf from "../header/SearchHelper";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Slider = () => {
  const data = useStaticQuery(graphql`
    query {
      img2: file(relativePath: { eq: "slider/main.png" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const { langCode } = React.useContext(I18nContext);

  const navCatsState = useSelector(
    state => state.menuReducer.navCats,
    shallowEqual
  );

  return (
    <>
      {/* <div id="homeBanner">
        <img src="https://ik.imagekit.io/bossrevolution/homepagelibrary/home-carousel-1920x500-1.jpg?tr=w-1400,h-500" />
      </div> */}

      <div>
        <div style={{
          background : "url('https://ik.imagekit.io/ofb/mall/main_CB9VajMLk.png')",
          minHeight : "550px",
          backgroundSize: "cover"
        }}>
            <div className="sliderBtns">
              <h1>SHOP . DINE . RELAX</h1>
              <p>The one-stop shopping destination with over 250 exciting stores & many services for you to explore as well as places to dine with friends {"&"} family or to be entertained all under one roof.</p>

              <div className="lineMain"></div>

              <ul>
                <li className="brig">
                  <div className="mainimagess"><img src="https://ik.imagekit.io/ofb/mall/time_gPONSidVK_.png" /></div>
                   <div className="mainimagessc"><span>mall timing</span><br/>
                   <b>09 : 00 AM - 11 : 00 PM</b></div>
                </li>
                <li>
                <div className="mainimagess"><img src="https://ik.imagekit.io/ofb/mall/map_d5MCDBhLJ.png" /></div>
                <div className="mainimagessc"><span>PLAN YOUR VISIT</span><br/>
                  <b><Link to="/interactive-mall-map">View Interactive Map</Link></b></div>
                </li>
              </ul>
            </div>            
          </div>
      </div>
      
    </>
  );
};

export default Slider;
